module.exports = __webpack_public_path__ + "c8d0d3749b7d7dced865b5ce98ec8953.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-chef.png
// module id = 1564
// module chunks = 0